import React from 'react';
import PropTypes from 'prop-types';
import { map, is } from 'ramda';

import MenuItem from 'material-ui/MenuItem';
import AutoComplete from 'components/AutoComplete';

import blacklist from 'lib/blacklist';

import diagnoses from '../../diagnoses';

import { view } from './SearchField.less';

const mapDiagnoses = localeMessage =>
  map(d => ({
    key: d,
    text: localeMessage(d),
    value: <MenuItem primaryText={localeMessage(d)} />,
  }));

const SearchField = ({ editing, input, localeMessage, hintLocale, formValues, type, ...other }) =>
  editing ? (
    <AutoComplete
      onChange={selection => is(Object, selection) && input.onChange(selection.key)}
      dataSource={mapDiagnoses(localeMessage)(diagnoses(type))}
      hintText={localeMessage(hintLocale)}
      menuProps={{
        maxHeight: 300,
      }}
      {...blacklist(['meta'], other)}
    />
  ) : (
    <div className={view}>{is(String, input.value) ? localeMessage(input.value) : null}</div>
  );

SearchField.propTypes = {
  editing: PropTypes.bool.isRequired,
  input: PropTypes.object.isRequired,
  localeMessage: PropTypes.func.isRequired,
  formValues: PropTypes.object,
  hintLocale: PropTypes.string,
  type: PropTypes.string,
};

export default SearchField;
